import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
import { ModelApi } from '@/api/ai/model/model';
import { ChatConversationApi } from '@/api/ai/chat/conversation';
import { AiModelTypeEnum } from '@/views/aip/utils/constants';
import { reactive, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
/** AI 聊天对话的更新表单 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'ChatConversationUpdateForm'
  },
  __name: 'ConversationUpdateForm',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    const dialogVisible = ref(false); // 弹窗的是否展示
    const formLoading = ref(false); // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
    const formData = ref({
      id: undefined,
      systemMessage: undefined,
      modelId: undefined,
      temperature: undefined,
      maxTokens: undefined,
      maxContexts: undefined
    });
    const formRules = reactive({
      modelId: [{
        required: true,
        message: '模型不能为空',
        trigger: 'blur'
      }],
      status: [{
        required: true,
        message: '状态不能为空',
        trigger: 'blur'
      }],
      temperature: [{
        required: true,
        message: '温度参数不能为空',
        trigger: 'blur'
      }],
      maxTokens: [{
        required: true,
        message: '回复数 Token 数不能为空',
        trigger: 'blur'
      }],
      maxContexts: [{
        required: true,
        message: '上下文数量不能为空',
        trigger: 'blur'
      }]
    });
    const formRef = ref(); // 表单 Ref
    const models = ref([]); // 聊天模型列表
    /** 打开弹窗 */
    const open = async id => {
      dialogVisible.value = true;
      resetForm();
      // 修改时，设置数据
      if (id) {
        formLoading.value = true;
        try {
          const data = await ChatConversationApi.getChatConversationMy(id);
          formData.value = Object.keys(formData.value).reduce((obj, key) => {
            if (data.hasOwnProperty(key)) {
              obj[key] = data[key];
            }
            return obj;
          }, {});
        } finally {
          formLoading.value = false;
        }
      }
      // 获得下拉数据
      models.value = await ModelApi.getModelSimpleList(AiModelTypeEnum.CHAT);
    };
    __expose({
      open
    }); // 提供 open 方法，用于打开弹窗
    /** 提交表单 */
    const emit = __emit; // 定义 success 事件，用于操作成功后的回调
    const submitForm = async () => {
      // 校验表单
      await formRef.value.validate();
      // 提交请求
      formLoading.value = true;
      try {
        const data = formData.value;
        await ChatConversationApi.updateChatConversationMy(data);
        message.success('对话配置已更新');
        dialogVisible.value = false;
        // 发送操作成功的事件
        emit('success');
      } finally {
        formLoading.value = false;
      }
    };
    /** 重置表单 */
    const resetForm = () => {
      formData.value = {
        id: undefined,
        systemMessage: undefined,
        modelId: undefined,
        temperature: undefined,
        maxTokens: undefined,
        maxContexts: undefined
      };
      formRef.value?.resetFields();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_Dialog = _resolveComponent("Dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_Dialog, {
        title: "设定",
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => dialogVisible.value = $event)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: submitForm,
          type: "primary",
          disabled: formLoading.value
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("确 定")])),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("取 消")])),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData.value,
          rules: formRules,
          "label-width": "130px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "角色设定",
            prop: "systemMessage"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: formData.value.systemMessage,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.systemMessage = $event),
              rows: 4,
              placeholder: "请输入角色设定"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模型",
            prop: "modelId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.value.modelId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.modelId = $event),
              placeholder: "请选择模型"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(models.value, model => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: model.id,
                  label: model.name,
                  value: model.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "温度参数",
            prop: "temperature"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: formData.value.temperature,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.temperature = $event),
              placeholder: "请输入温度参数",
              min: 0,
              max: 2,
              precision: 2,
              class: "!w-1/1"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "回复数 Token 数",
            prop: "maxTokens"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: formData.value.maxTokens,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.maxTokens = $event),
              placeholder: "请输入回复数 Token 数",
              min: 0,
              max: 8192,
              class: "!w-1/1"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "上下文数量",
            prop: "maxContexts"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: formData.value.maxContexts,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.maxContexts = $event),
              placeholder: "请输入上下文数量",
              min: 0,
              max: 20,
              class: "!w-1/1"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])), [[_directive_loading, formLoading.value]])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});